/* global TrelloPowerUp */
const { setGlobalTheme } = require('@atlaskit/tokens/dist/cjs');

const init = () => {
  const t = TrelloPowerUp.iframe({
    targetOrigin: 'https://trello.com',
  });

  if (t.getContext() && t.getContext().colorMode) {
    setGlobalTheme({ colorMode: t.getContext().colorMode });
  }
};

window.initGlobalTheme = init;
module.exports.init = init;
